import styled from 'styled-components'

const Invalid = (props) => {
  const { invalid, textAlign } = props

  const invalidCss = invalid ? 'invalid' : ''

  return (
    <View className={invalidCss} textAlign={textAlign}>
      {invalid || ''}
    </View>
  )
}

const View = styled.div`
  color: #f95247;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 500;
  text-align: ${(p) => p.textAlign || 'left'};
  display: none;

  &.invalid {
    display: block;
  }
`

export default Invalid
